import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.productionplan';

export default defineMessages({


  manipulateChart: {
    id: `${scope}.gantt.labels.manipulateChart`,
    defaultMessage: 'Chart zoom & pan',
  },
  showDataInChart: {
    id: `${scope}.gantt.labels.showDataInChart`,
    defaultMessage: 'Show data in chart',
  },
  showBlockLabel: {
    id: `${scope}.gantt.labels.showBlockLabel`,
    defaultMessage: 'Show block label',
  },
  rearrangeFunctions: {
    id: `${scope}.gantt.labels.rearrangeFunctions`,
    defaultMessage: 'Rearrange functions',
  },
  labelPo: {
    id: `${scope}.gantt.labels.labelPo`,
    defaultMessage: 'PO',
  },
  labelTool: {
    id: `${scope}.gantt.labels.labelTool`,
    defaultMessage: 'Tool',
  },
  labelArticle: {
    id: `${scope}.gantt.labels.labelArticle`,
    defaultMessage: 'Item',
  },

  zoomIn: {
    id: `${scope}.gantt.actions.zoomIn`,
    defaultMessage: 'Zoom in',
  },
  zoomOut: {
    id: `${scope}.gantt.actions.zoomOut`,
    defaultMessage: 'Zoom out',
  },
  zoomToNow: {
    id: `${scope}.gantt.actions.zoomToNow`,
    defaultMessage: 'Zoom to now',
  },
  zoomToFullInterval: {
    id: `${scope}.gantt.actions.zoomToFullInterval`,
    defaultMessage: 'Zoom to full interval',
  },
  onlyRunningSwitch: {
    id: `${scope}.gantt.actions.onlyRunningSwitch`,
    defaultMessage: 'Only Running',
  },
  showCalcEndSwitch: {
    id: `${scope}.gantt.actions.showCalcEndSwitch`,
    defaultMessage: 'Calculated End',
  },
  suggestPlanningSwitch: {
    id: `${scope}.gantt.actions.suggestPlanningSwitch`,
    defaultMessage: 'Suggest planning',
  },
  showOriginalSwitch: {
    id: `${scope}.gantt.actions.showOriginalSwitch`,
    defaultMessage: 'Show planned',
  },
  showCalendarSwitch: {
      id: `${scope}.gantt.actions.showCalendarSwitch`,
      defaultMessage: 'Show calendar',
    },
  showUnsavedSwitch: {
    id: `${scope}.gantt.actions.showUnsavedSwitch`,
    defaultMessage: 'Show unsaved',
  },
  onlyRunningTooltip: {
    id: `${scope}.gantt.actions.onlyRunningTooltip`,
    defaultMessage: 'Show only running TOs in the Gantt chart',
  },
  showCalcEndTooltip: {
    id: `${scope}.gantt.actions.showCalcEndTooltip`,
    defaultMessage: 'Show calculated end times for running and planned TOs in the Gantt chart',
  },
  showOriginalTooltip: {
    id: `${scope}.gantt.actions.showOriginalTooltip`,
    defaultMessage: 'Show original planned tasks in the Gantt chart',
  },
  suggestPlanningTooltip: {
    id: `${scope}.gantt.actions.suggestPlanningTooltip`,
    defaultMessage: 'Show suggested planning in the Gantt chart based on OEE and compact ordering',
  },
  showCalendarTooltip: {
    id: `${scope}.gantt.actions.showCalendarTooltip`,
    defaultMessage: 'Show calendar blocks in the Gantt chart',
  },
  showUnsavedTooltip: {
    id: `${scope}.gantt.actions.showUnsavedTooltip`,
    defaultMessage: 'Show unsaved changes in the Gantt chart',
  },

  thisWeek: {
    id: `${scope}.gantt.actions.thisWeek`,
    defaultMessage: 'Current week',
  },
  thisMonth: {
    id: `${scope}.gantt.actions.thisMonth`,
    defaultMessage: 'Current month',
  },
  threeMonths: {
    id: `${scope}.gantt.actions.threeMonths`,
    defaultMessage: 'Three months',
  },
  machines: {
    id: `${scope}.gantt.actions.machines`,
    defaultMessage: 'Machines',
  },
  areas: {
    id: `${scope}.gantt.actions.areas`,
    defaultMessage: 'Areas',
  },
  groupBy: {
    id: `${scope}.gantt.actions.groupBy`,
    defaultMessage: 'Group by',
  },
  no: {
    id: `${scope}.gantt.actions.no`,
    defaultMessage: 'No',
  },
  yes: {
    id: `${scope}.gantt.actions.yes`,
    defaultMessage: 'Yes',
  },
  saveAllConfirmationTitle: {
    id: `${scope}.gantt.actions.saveAllConfirmationTitle`,
    defaultMessage: 'Confirm save all',
  },
  saveAllConfirmationMessage: {
    id: `${scope}.gantt.actions.saveAllConfirmationMessage`,
    defaultMessage: 'Are you sure you want to save all changes? All changes for visible machines will be saved.',
  },
  cancelAllConfirmationTitle: {
    id: `${scope}.gantt.actions.cancelAllConfirmationTitle`,
    defaultMessage: 'Confirm cancel all',
  },
  cancelAllConfirmationMessage: {
    id: `${scope}.gantt.actions.cancelAllConfirmationMessage`,
    defaultMessage: 'Are you sure you want to cancel all changes for visible machines? All changes for visible machines will be reverted to the original values.',
  },
  saveMarkedRowsConfirmationTitle: {
    id: `${scope}.gantt.actions.saveMarkedRowsConfirmationTitle`,
    defaultMessage: 'Confirm update marked rows',
  },
  saveMarkedRowsConfirmationMessage: {
    id: `${scope}.gantt.actions.saveMarkedRowsConfirmationMessage`,
    defaultMessage: 'Are you sure you want to save the marked rows? All marked rows planning will be updated with the suggested planning',
  },

  saveMachineConfirmationTitle: {
    id: `${scope}.gantt.actions.saveMachineConfirmationTitle`,
    defaultMessage: 'Confirm update machine',
  },
  saveMachineConfirmationMessage: {
    id: `${scope}.gantt.actions.saveMachineConfirmationMessage`,
    defaultMessage: 'Are you sure you want to save the changes to the machine? The machine will be updated with the new value.',
  },
  cancelMachineConfirmationTitle: {
    id: `${scope}.gantt.actions.cancelMachineConfirmationTitle`,
    defaultMessage: 'Confirm cancel machine changes',
  },
  cancelMachineConfirmationMessage: {
    id: `${scope}.gantt.actions.cancelMachineConfirmationMessage`,
    defaultMessage: 'Are you sure you want to cancel the changes to the machine? The machine will be reverted to the original value.',
  },

  details: {
    id: `${scope}.dialog.labels.details`,
    defaultMessage: 'Details for production order: ',
  },
  article: {
    id: `${scope}.dialog.labels.article`,
    defaultMessage: 'Article: ',
  },

  startTime: {
    id: `${scope}.dialog.labels.startTime`,
    defaultMessage: 'Start time',
  },
  endTime: {
    id: `${scope}.dialog.labels.endTime`,
    defaultMessage: 'End time',
  },
  duration: {
    id: `${scope}.dialog.labels.duration`,
    defaultMessage: 'Duration',
  },
  result: {
    id: `${scope}.dialog.labels.result`,
    defaultMessage: 'Actual',
  },
  planned: {
    id: `${scope}.dialog.labels.planned`,
    defaultMessage: 'Planned',
  },
  replanned: {
    id: `${scope}.dialog.labels.replanned`,
    defaultMessage: 'Replanned',
  },
  calculated: {
    id: `${scope}.dialog.labels.calculated`,
    defaultMessage: 'Calculated',
  },
    plannedInfo: {
    id: `${scope}.dialog.labels.plannedInfo`,
    defaultMessage: 'Planned times for the order',
  },
  replannedInfo: {
    id: `${scope}.dialog.labels.replannedInfo`,
    defaultMessage: 'Replanned times for the order',
  },
  calculatedInfo: {
    id: `${scope}.dialog.labels.calculatedInfo`,
    defaultMessage: 'Calculated times for the order. Start time is based on first received data. End time is calculated based on the orders progress.',
  },

  a: {
    id: `${scope}.dialog.labels.a`,
    defaultMessage: 'A',
  },
  p: {
    id: `${scope}.dialog.labels.p`,
    defaultMessage: 'P',
  },
  q: {
    id: `${scope}.dialog.labels.q`,
    defaultMessage: 'Q',
  },
  oee: {
    id: `${scope}.dialog.labels.oee`,
    defaultMessage: 'OEE',
  },

  machine: {
    id: `${scope}.dialog.labels.machine`,
    defaultMessage: 'Machine',
  },
  po: {
    id: `${scope}.dialog.labels.po`,
    defaultMessage: 'Production order',
  },
  articleDescription: {
    id: `${scope}.dialog.labels.articleDescription`,
    defaultMessage: 'Article',
  },
  tool: {
    id: `${scope}.dialog.labels.tool`,
    defaultMessage: 'Tool',
  },

  idealCT: {
    id: `${scope}.dialog.labels.idealCT`,
    defaultMessage: 'Ideal cycle time',
  },
  actualCT: {
    id: `${scope}.dialog.labels.actualCT`,
    defaultMessage: 'Actual cycle time',
  },
  poRuntime: {
    id: `${scope}.dialog.labels.poRuntime`,
    defaultMessage: 'Production order runtime',
  },
  prodPerCycle: {
    id: `${scope}.dialog.labels.prodPerCycle`,
    defaultMessage: 'Prod./cycle',
  },

  nrOfCycles: {
    id: `${scope}.dialog.labels.nrOfCycles`,
    defaultMessage: 'Number of cycles',
  },
  scrapped: {
    id: `${scope}.dialog.labels.scrapped`,
    defaultMessage: 'Scrapped',
  },

  runtime: {
    id: `${scope}.dialog.labels.runtime`,
    defaultMessage: 'Runtime',
  },
  downtime: {
    id: `${scope}.dialog.labels.downtime`,
    defaultMessage: 'Downtime',
  },
  totalTime: {
    id: `${scope}.dialog.labels.totalTime`,
    defaultMessage: 'Total Time',
  },
  plannedQty: {
    id: `${scope}.dialog.labels.plannedQty`,
    defaultMessage: 'Planned QTY',
  },
  reportedQty: {
    id: `${scope}.dialog.labels.reportedQty`,
    defaultMessage: 'Reported QTY',
  },
  remainingQty: {
    id: `${scope}.dialog.labels.remainingQty`,
    defaultMessage: 'Remaining QTY',
  },
  percentageDone: {
    id: `${scope}.dialog.labels.percentageDone`,
    defaultMessage: 'Percentage done',
  },
  comingSoon: {
    id: `${scope}.labels.comingSoon`,
    defaultMessage: 'This module is coming soon.',
  },

  zoomIn: {
    id: `${scope}.gantt.actions.zoomIn`,
    defaultMessage: 'Zoom in',
  },
  zoomOut: {
    id: `${scope}.gantt.actions.zoomOut`,
    defaultMessage: 'Zoom out',
  },
  zoomToNow: {
    id: `${scope}.gantt.actions.zoomToNow`,
    defaultMessage: 'Zoom to now',
  },
  zoomToFullInterval: {
    id: `${scope}.gantt.actions.zoomToFullInterval`,
    defaultMessage: 'Zoom to full interval',
  },
  legendLegend: {
    id: `${scope}.gantt.legend.legend`,
    defaultMessage: 'Legend',
  },
  legendSymbols: {
    id: `${scope}.gantt.legend.symbols`,
    defaultMessage: 'Symbols',
  },

  legendRunning: {
    id: `${scope}.gantt.legend.running`,
    defaultMessage: 'Running',
  },
  legendFinished: {
    id: `${scope}.gantt.legend.finished`,
    defaultMessage: 'Finished',
  },
  legendNotSaved: {
    id: `${scope}.gantt.legend.notSaved`,
    defaultMessage: 'Not saved',
  },
  legendPlanned: {
    id: `${scope}.gantt.legend.planned`,
    defaultMessage: 'Planned',
  },
  legendBehindSchedule: {
    id: `${scope}.gantt.legend.behindSchedule`,
    defaultMessage: 'Behind schedule',
  },

  legendReportedQty: {
    id: `${scope}.gantt.legend.reportedQty`,
    defaultMessage: 'Reported qty',
  },
  legendBlocker: {
    id: `${scope}.gantt.legend.blocker`,
    defaultMessage: 'Blocker',
  },


  editButton: {
    id: `${scope}.gantt.actions.editButton`,
    defaultMessage: 'Edit',
  },
  snappingButton: {
    id: `${scope}.gantt.actions.snappingButton`,
    defaultMessage: 'Snapping',
  },
  rearrangeButton: {
    id: `${scope}.gantt.actions.rearrangeButton`,
    defaultMessage: 'Rearrange',
  },
  recalculateButton: {
    id: `${scope}.gantt.actions.recalculateButton`,
    defaultMessage: 'Recalc',
  },
  cancelAllButton: {
    id: `${scope}.gantt.actions.cancelAllButton`,
    defaultMessage: 'Cancel all',
  },
  saveAllButton: {
    id: `${scope}.gantt.actions.saveAllButton`,
    defaultMessage: 'Save all',
  },
  updateRowsButton: {
    id: `${scope}.gantt.actions.updateRowsButton`,
    defaultMessage: 'Update rows',
  },
  snappingButtonInfo: {
    id: `${scope}.gantt.actions.snappingButtonInfo`,
    defaultMessage: 'Enable or disable snapping to previous order when dragging orders in the Gantt chart.',
  },
  rearrangeButtonInfo: {
    id: `${scope}.gantt.actions.rearrangeButtonInfo`,
    defaultMessage: 'Enable or disable automatic rearranging of overlapping orders when dragging orders in the Gantt chart.',
  },
  recalculateButtonInfo: {
    id: `${scope}.gantt.actions.recalculateButtonInfo`,
    defaultMessage: 'Enable or disable automatic recalculation of affected orders when dragging orders in the Gantt chart.',
  },

  tabAddOrder: {
    id: `${scope}.add.labels.tabs.addOrder`,
    defaultMessage: 'Add order',
  },
  tabAddBlocker: {
    id: `${scope}.add.labels.tabs.addBlocker`,
    defaultMessage: 'Add blocker',
  },
  btnAddOrder: {
    id: `${scope}.add.labels.btn.addOrder`,
    defaultMessage: 'Add order',
  },
  btnAddBlocker: {
    id: `${scope}.add.labels.btn.addBlocker`,
    defaultMessage: 'Add blocker',
  },
  btnEditBlockers: {
    id: `${scope}.add.labels.btn.editBlockers`,
    defaultMessage: 'Edit blockers',
  },
  newPplLabelHistoricOee: {
    id: `${scope}.add.labels.newPplLabelHistoricOee`,
    defaultMessage: 'Historic OEE',
  },
  newPplLabelOee: {
    id: `${scope}.add.labels.newPplLabelOee`,
    defaultMessage: 'OEE',
  },
  newPplLabelStockBalance: {
    id: `${scope}.add.labels.newPplLabelStockBalance`,
    defaultMessage: 'Stock Balance',
  },
  newPplLabelReservedBalance: {
    id: `${scope}.add.labels.newPplLabelReservedBalance`,
    defaultMessage: 'Reserved Balance',
  },
  newPplLabelToolId: {
    id: `${scope}.add.labels.newPplLabelToolId`,
    defaultMessage: 'Tool ID',
  },
  newPplLabelLastArticleForTool: {
    id: `${scope}.add.labels.newPplLabelLastArticleForTool`,
    defaultMessage: 'Last article',
  },

  newPplLabelSwitchSnap: {
    id: `${scope}.add.labels.newPplLabelSwitchSnap`,
    defaultMessage: "Snap to previous order's end time (spacing by predefined interval)",
  },
  newPplLabelSwitchReplan: {
    id: `${scope}.add.labels.newPplLabelSwitchReplan`,
    defaultMessage: "Replan if overlapping orders",  
  },
  newPplLabelSwitchRecalculate: {
    id: `${scope}.add.labels.newPplLabelSwitchRecalculate`,
    defaultMessage: "Recalculate end time for affected orders",  
  },
  newPplLabelWarnOverlap: {
    id: `${scope}.add.labels.newPplLabelWarnOverlap`,
    defaultMessage: "Overlapping plans will cause replanning of overlapped and subsequent plans",  
  },
  newPplLabelIdealRuntime: {
    id: `${scope}.add.labels.newPplLabelIdealRuntime`,
    defaultMessage: "Ideal runtime",  
  },
  newPplLabelHours: {
    id: `${scope}.add.labels.newPplLabelHours`,
    defaultMessage: "hours",  
  },
  newPplLabelMinutes: {
    id: `${scope}.add.labels.newPplLabelMinutes`,
    defaultMessage: "minutes",  
  },
  newPplLabelStartDate: {
    id: `${scope}.add.labels.newPplLabelStartDate`,
    defaultMessage: "Start date",  
  },
  newPplLabelStartTime: {
    id: `${scope}.add.labels.newPplLabelStartTime`,
    defaultMessage: "Start time",  
  },
  newPplLabelEndDate: {
    id: `${scope}.add.labels.newPplLabelEndDate`,
    defaultMessage: "End date",  
  },
  newPplLabelEndTime: {
    id: `${scope}.add.labels.newPplLabelEndTime`,
    defaultMessage: "End time",  
  },
  newPplLabelQuantity: {
    id: `${scope}.add.labels.newPplLabelQuantity`,
    defaultMessage: "Quantity",  
  },
  newPplLabelMachine: {
    id: `${scope}.add.labels.newPplLabelMachine`,
    defaultMessage: "Machine",  
  },
  newPplLabelItem: {
    id: `${scope}.add.labels.newPplLabelItem`,
    defaultMessage: "Item",  
  },
  newPplLabelBlocker: {
    id: `${scope}.add.labels.newPplLabelBlocker`,
    defaultMessage: "Blocker type",  
  },
  newPplLabelHeadline: {
    id: `${scope}.add.labels.newPplLabelHeadline`,
    defaultMessage: "Add and plan production order",  
  },
  newPplLabelYes: {
    id: `${scope}.add.labels.newPplLabelYes`,
    defaultMessage: "Yes",  
  },
  newPplLabelNo: {
    id: `${scope}.add.labels.newPplLabelNo`,
    defaultMessage: "No",  
  },

  updPplLabelUpdatingOrder: {
    id: `${scope}.upd.labels.updPplLabelUpdatingOrder`,
    defaultMessage: "Updating order",  
  },
  updPplLabelProduct: {
    id: `${scope}.upd.labels.updPplLabelProduct`,
    defaultMessage: "Product",  
  },
  updPplLabelCurrentMachine: {
    id: `${scope}.upd.labels.updPplLabelCurrentMachine`,
    defaultMessage: "Current Machine",  
  },
  updPplBtnUpdateOrder: {
    id: `${scope}.upd.labels.btn.updPplBtnUpdateOrder`,
    defaultMessage: "Update Order",  
  },
});